import { render } from "./SurveyTable.vue?vue&type=template&id=31e7fe90"
import script from "./SurveyTable.vue?vue&type=script&lang=ts"
export * from "./SurveyTable.vue?vue&type=script&lang=ts"
script.render = render

export default script